var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotif13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9953,
    viewBox: "0 0 16 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.99767C0 3.58072 3.58176 0 8 0C12.4182 0 16 3.58072 16 7.99767C16 12.4146 12.4182 15.9953 8 15.9953C3.58176 15.9953 0 12.4146 0 7.99767Z",
    fill: "#508FCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.58617 8.02513C3.58617 5.573 5.5747 3.58505 8.02755 3.58505C10.4804 3.58505 12.4689 5.573 12.4689 8.02513C12.4689 10.4773 10.4804 12.4652 8.02755 12.4652C5.5747 12.4652 3.58617 10.4773 3.58617 8.02513Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif13);
export default __webpack_public_path__ + "static/media/motif-13.67b181f518ad4fc2836a68b530244e36.svg";
export { ForwardRef as ReactComponent };